import axios from 'axios';
import { safeLocalStorage } from "@utils/localstorage";

const localStorageToken = safeLocalStorage.getItem('loginToken')

const axiosApi = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
});

export const setAuthHeader = token => {
  axiosApi.defaults.headers.common.Authorization = `Bearer ${token || localStorageToken}`;
};

axiosApi.defaults.headers.common.Authorization = `Bearer ${localStorageToken}`;

axiosApi.interceptors.response.use(
  response => {
    // If the request succeeds, return the response directly
    return response;
  },
  error => {
    if (error.response) {
      // Mark that this was an error response so callers can detect it
      error.response._isErrorResponse = true;
      return error.response;
    } else if (error.request) {
      // Network error - no response received. Return a consistent shape
      // instead of raw XMLHttpRequest so callers can detect it
      console.warn('API unreachable (network):', error.message);
      return {
        data: null,
        status: 0,
        _isErrorResponse: true,
        _isNetworkError: true
      };
    } else {
      console.error('Request setup error:', error.message);
      return {
        data: null,
        status: 0,
        _isErrorResponse: true
      };
    }
  }
);

setAuthHeader(localStorageToken);

export default axiosApi;